// extracted by mini-css-extract-plugin
module.exports = {"container":"dialogFooter_container__n6WEs"};